module.exports = __webpack_public_path__ + "static/media/dm.cffeea69.png";